import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import ReactLoading from 'react-loading';
import axios from "axios";
import { Resetpassurl } from '../Utils/urls';
import { primarycolor } from '../Utils/colors';

let color = "white";
let type = "spokes";



export default function Resetpassword({ successsignup, cancelsignup }) {

    const [progress, setprogress] = useState(false);
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState("");

    const handleSubmit = (event) => {
        seterror(null)
        setprogress(true)
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const email = data.get('email')

        if (!email) {
            seterror("Enter an email to receive reset link")
            setprogress(false)
        } else {
            seterror(null)
            axios.post(Resetpassurl, {
                email: email,
            }).then(response => {
                setprogress(false)
                if (!response.data.message) {
                    setsuccess("Success.Reset link has been sent to the email provided")
                    setTimeout(() => {
                        cancelsignup()
                    }, 5000);
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setprogress(false)
                seterror("Sorry an error occurred,try again later");


            });
        }

    };





    return (
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Avatar sx={{ m: 1, bgcolor: primarycolor }}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Reset password
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                />
                {success && <div style={{ color: "green", fontSize: 10 }}>{success}</div>}
                {error && <div style={{ color: "red", fontSize: 10 }}>{error}</div>}
                <Button
                    type="submit"
                    fullWidth
                    style={{ backgroundColor: primarycolor }}
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    {progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Get link"}
                </Button>
                <Grid container>
                    <Grid item xs>
                        <Link href="#" variant="body2">

                        </Link>
                    </Grid>
                    <Grid item>
                        <Link onClick={() => cancelsignup()} style={{ color: primarycolor, fontSize: 13 }} to="" variant="body2">
                            {"Don't have an account? Sign Up"}
                        </Link>
                    </Grid>
                </Grid>
            </Box>
        </Box>

    );
}